<div class="fixed inset-0 z-50 flex items-center justify-center px-4 py-6">
  <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="handleCloseModal(1)"></div>
  <main class="relative w-full max-w-5xl max-h-[90vh] overflow-hidden rounded-2xl border border-border-color bg-white shadow-2xl">
    <header class="flex flex-col gap-4 border-b border-border-color bg-light-color/60 px-6 py-5">
      <div class="flex items-start justify-between gap-4">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Disparo oficial</p>
          <h3 class="text-lg font-semibold text-dark-color">Importar contatos via CSV</h3>
          <p class="text-sm text-dark-color/70">Complete as etapas para configurar o disparo oficial.</p>
        </div>
        <button
          id="close_button"
          aria-label="Close modal"
          class="rounded-lg p-2 text-dark-color/70 transition hover:bg-light-color/70 hover:text-dark-color"
          (click)="handleCloseModal(1)">
          <i class="fa-solid fa-xmark fa-lg"></i>
        </button>
      </div>

      <div class="flex flex-wrap gap-2">
        <button
          type="button"
          class="rounded-full border px-4 py-2 text-xs font-semibold uppercase tracking-[0.12em] transition"
          [ngClass]="stepForm === 1 ? 'border-primary-color bg-white text-primary-color shadow-sm' : 'border-border-color text-dark-color/70 hover:text-dark-color'">
          Informacoes
        </button>
        <button
          type="button"
          class="rounded-full border px-4 py-2 text-xs font-semibold uppercase tracking-[0.12em] transition"
          [ngClass]="stepForm === 2 ? 'border-primary-color bg-white text-primary-color shadow-sm' : 'border-border-color text-dark-color/70 hover:text-dark-color'">
          Variaveis e botoes
        </button>
        <button
          type="button"
          class="rounded-full border px-4 py-2 text-xs font-semibold uppercase tracking-[0.12em] transition"
          [ngClass]="stepForm === 3 ? 'border-primary-color bg-white text-primary-color shadow-sm' : 'border-border-color text-dark-color/70 hover:text-dark-color'">
          Canais
        </button>
        <button
          type="button"
          class="rounded-full border px-4 py-2 text-xs font-semibold uppercase tracking-[0.12em] transition"
          [ngClass]="stepForm === 4 ? 'border-primary-color bg-white text-primary-color shadow-sm' : 'border-border-color text-dark-color/70 hover:text-dark-color'">
          Agendamentos
        </button>
      </div>
    </header>

    <section id="form_section" class="max-h-[70vh] overflow-y-auto px-6 py-6">
      <div [ngClass]="stepForm === 1 ? 'block' : 'hidden'">
        <form id="import_form" class="space-y-4" [formGroup]="formOficialCsv">
          <div id="file_upload_block" class="space-y-3">
            <label class="block text-sm text-dark-color">Importar contatos <span class="text-dark-color/60">*</span></label>
            <div class="relative space-y-4">
              <div class="flex items-center w-full rounded-xl border-2 border-dashed border-border-color bg-light-color/60 transition hover:border-primary-color">
                <label
                  for="file_input_trigger"
                  class="cursor-pointer rounded-l-xl border-r border-border-color bg-white px-6 py-3 text-sm text-dark-color transition hover:bg-light-color">
                  <i class="fa-solid fa-upload mr-2"></i>Escolher arquivo
                </label>
                <input
                  id="file_input_trigger"
                  type="file"
                  class="sr-only"
                  accept=".csv"
                  (change)="handleAddCsvFile($event)"
                />
                <span class="pl-4 text-sm text-dark-color/70 truncate flex-1">
                  @if (fileName.length > 0) { {{ fileName }} } @else { {{ "Selecione um arquivo" }} }
                </span>
              </div>

              <div class="space-y-3">
                <label class="block text-sm text-dark-color">Arquivo de midia <span class="text-dark-color/60">*</span></label>
                <div class="flex items-center w-full rounded-xl border-2 border-dashed border-border-color bg-light-color/60 transition hover:border-primary-color">
                  <label
                    for="file_input_midia"
                    class="cursor-pointer rounded-l-xl border-r border-border-color bg-white px-6 py-3 text-sm text-dark-color transition hover:bg-light-color">
                    <i class="fa-solid fa-upload mr-2"></i>Escolher arquivo
                  </label>
                  <input
                    id="file_input_midia"
                    type="file"
                    class="sr-only"
                    accept=".jpeg"
                    (change)="onFilesSelected($event)"
                  />
                  <span class="pl-4 text-sm text-dark-color/70 truncate flex-1">
                    @if (fileNameMidia.length > 0) { {{ fileNameMidia }} } @else { {{ "Selecione um arquivo" }} }
                  </span>
                </div>
              </div>
            </div>
            <p class="text-xs text-dark-color/70 flex items-center">
              <i class="fa-solid fa-info-circle mr-2 text-dark-color/40"></i>Apenas arquivos CSV sao aceitos
            </p>
          </div>

          <div id="ignore_line_block" class="flex items-center rounded-lg border border-border-color bg-light-color/60 px-3 py-2">
            <input
              formControlName="ignoreRow"
              id="ignore_first_line"
              type="checkbox"
              class="h-4 w-4 text-primary-color border-border-color rounded"
            />
            <label for="ignore_first_line" class="ml-3 block text-sm text-dark-color">Ignorar primeira linha do arquivo</label>
          </div>

          <div class="grid grid-cols-1 gap-4">
            <div id="template_id_block" class="space-y-2">
              <label for="template_id" class="block text-sm text-dark-color">Nome da Campanha <span class="text-dark-color/60">*</span></label>
              <input
                formControlName="campanha"
                type="text"
                id="template_id"
                placeholder="Digite o nome da campanha"
                class="w-full rounded-base border border-border-color px-4 py-3 text-sm outline-none focus:border-primary-color"
              />
              <p class="text-xs text-dark-color/70">Nome da campanha</p>
            </div>
          </div>

          <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div id="template_id_block" class="space-y-2">
              <label for="template_id" class="block text-sm text-dark-color">Template ID <span class="text-dark-color/60">*</span></label>
              <div class="relative">
                <input
                  formControlName="idTemplate"
                  type="number"
                  id="template_id"
                  placeholder="Digite o template ID"
                  class="w-full rounded-base border border-border-color px-4 py-3 text-sm outline-none focus:border-primary-color"
                />
                <i class="fa-solid fa-hashtag absolute right-4 top-3.5 text-dark-color/40"></i>
              </div>
              <p class="text-xs text-dark-color/70">ID da mensagem template</p>
            </div>

            <div id="phone_column_block" class="space-y-2">
              <label for="phone_column" class="block text-sm text-dark-color">Coluna do Telefone <span class="text-dark-color/60">*</span></label>
              <div class="relative">
                <select
                  formControlName="colunaTelefone"
                  id="phone_column"
                  class="w-full appearance-none rounded-base border border-border-color bg-white px-4 py-3 pr-10 text-sm outline-none focus:border-primary-color">
                  <option value="" disabled selected>Selecione uma coluna</option>
                  <option *ngFor="let column of columns" [value]="column.value">{{ column.column }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-dark-color/50">
                  <i class="fa-solid fa-chevron-down"></i>
                </div>
              </div>
              <p class="text-xs text-dark-color/70">Coluna com numeros de telefone</p>
            </div>
          </div>

          <footer class="flex flex-col gap-2 border-t border-border-color pt-4 sm:flex-row sm:justify-end sm:gap-3">
            <button
              (click)="handleCloseModal(1)"
              id="cancel_button"
              type="button"
              class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color">
              Cancelar
            </button>
            <button
              (click)="nextStep()"
              [disabled]="!handleValidStepOne()"
              id="continue_button"
              type="submit"
              class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-60">
              <i class="fa-solid fa-arrow-right mr-2"></i>Continuar
            </button>
          </footer>
        </form>
      </div>

      <div [ngClass]="stepForm === 2 ? 'block' : 'hidden'">
        <form id="import_form" class="space-y-6" [formGroup]="formOficialCsv">
          <section id="channels_section" class="rounded-xl border border-border-color bg-light-color/40 p-5">
            <div class="space-y-6">
              <div class="rounded-xl border border-border-color bg-white shadow-sm">
                <div class="flex flex-col gap-2 border-b border-border-color px-4 py-3 md:flex-row md:items-center md:justify-between">
                  <h3 class="text-sm font-semibold text-dark-color">Variaveis</h3>
                  <small class="text-xs text-dark-color/60">
                    Devem obedecer a sequencia do template cadastrado no gestor.
                  </small>
                </div>

                <div class="px-4 py-4">
                  <div class="flex flex-col gap-3 lg:flex-row lg:items-center">
                    <select
                      (change)="handleChangeOptionSelectedAddVariable($event)"
                      name="optionSelectedAddVariable"
                      class="w-full rounded-base border border-border-color bg-white px-3 py-2 text-sm outline-none focus:border-primary-color lg:w-64">
                      <option value="" disabled selected>Selecione uma variavel…</option>
                      <option *ngFor="let column of columns" [value]="column.value">{{ column.column }}</option>
                    </select>

                    <div class="flex flex-wrap items-center gap-2">
                      <button
                        type="button"
                        (click)="handleAddVariableInTemplate()"
                        class="inline-flex items-center rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
                        + Adicionar variavel
                      </button>

                      <button
                        type="button"
                        (click)="handleClearAllVariables()"
                        class="inline-flex items-center rounded-base border border-border-color bg-light-color px-4 py-2 text-sm font-semibold text-dark-color transition hover:border-primary-color">
                        Limpar tudo
                      </button>
                    </div>
                  </div>
                </div>

                <div class="px-4 pb-4">
                  <div class="grid grid-cols-1 gap-2 sm:grid-cols-2 max-h-48 overflow-y-auto pr-2">
                    <div
                      class="flex items-center justify-between gap-2 rounded-lg border border-border-color bg-light-color/60 px-3 py-2"
                      *ngFor="let variable of referedVariables.controls; index as i">
                      <span class="text-sm font-medium text-dark-color truncate">
                        {{ getTraductionColumn(variable.value) }}
                      </span>
                      <button
                        type="button"
                        aria-label="Remover variavel"
                        class="rounded-base bg-red-100 px-3 py-1.5 text-xs font-medium text-red-700 hover:bg-red-200"
                        (click)="handleRemoveVariable(i)">
                        Remover
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <footer class="flex flex-col gap-2 border-t border-border-color pt-4 sm:flex-row sm:justify-end sm:gap-3">
            <button
              (click)="previousStep()"
              id="cancel_button_3"
              type="button"
              class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color">
              Voltar
            </button>
            <button
              (click)="nextStep()"
              id="continue_button_3"
              type="submit"
              class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
              <i class="fa-solid fa-arrow-right mr-2"></i>Continuar
            </button>
          </footer>
        </form>
      </div>

      <div [ngClass]="stepForm === 3 ? 'block' : 'hidden'">
        <form id="import_form" class="space-y-6" [formGroup]="formOficialCsv">
          <section id="channels_section" class="rounded-xl border border-border-color bg-light-color/40 p-5">
            <div id="channels_content_block" class="space-y-4">
              <label for="channels_list" class="block text-sm text-dark-color">Canais que deseja disparar: <span class="text-dark-color/60">*</span></label>
              <div
                id="channels_list"
                class="rounded-lg border border-border-color bg-white shadow-sm"
                *ngFor="let canal of listChannels">
                <div class="flex items-center justify-between p-4">
                  <div class="flex items-center gap-3">
                    <input
                      [id]="canal.idcanal"
                      [value]="canal.idcanal"
                      (change)="handleSelectChannel($event)"
                      [disabled]="canal.status === 'Desconectado'"
                      type="checkbox"
                      class="h-4 w-4 text-primary-color border-border-color rounded"
                    />
                    <label [htmlFor]="canal.idcanal" class="text-sm text-dark-color">{{ canal.nomefila }}</label>
                  </div>
                  <div class="flex items-center gap-2">
                    <div
                      class="h-2.5 w-2.5 rounded-full"
                      [ngClass]="{
                        'bg-green-500': canal.status === 'Conectado',
                        'bg-red-500': canal.status === 'Desconectado'
                      }"></div>
                    <span class="text-xs uppercase tracking-wider text-dark-color/70">{{ canal.status }}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <footer class="flex flex-col gap-2 border-t border-border-color pt-4 sm:flex-row sm:justify-end sm:gap-3">
            <button
              (click)="previousStep()"
              id="cancel_button_3"
              type="button"
              class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color">
              Voltar
            </button>
            <button
              (click)="nextStep()"
              id="continue_button_3"
              type="submit"
              class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
              <i class="fa-solid fa-arrow-right mr-2"></i>Continuar
            </button>
          </footer>
        </form>
      </div>

      <div [ngClass]="stepForm === 4 ? 'block' : 'hidden'">
        <form id="import_form" class="space-y-6" [formGroup]="formOficialCsv">
          <section id="scheduling_form_section" class="rounded-xl border border-border-color bg-light-color/40 p-5">
            <div id="personalized_sending_block" class="space-y-4">
              <label class="block text-sm text-dark-color">Envio personalizado: <span class="text-dark-color/60">*</span></label>
              <div class="space-y-4">
                <div id="schedule_send_option" class="flex flex-col gap-2 sm:flex-row sm:items-center">
                  <div class="flex items-center">
                    <input
                      (change)="handleIsScheduled($event)"
                      id="schedule_send_checkbox"
                      type="checkbox"
                      class="h-4 w-4 text-primary-color border-border-color rounded"
                    />
                    <label for="schedule_send_checkbox" class="ml-3 block text-sm text-dark-color">Agendar envio</label>
                  </div>
                  <input
                    formControlName="data"
                    *ngIf="isScheduled"
                    id="schedule_date"
                    type="date"
                    class="w-full rounded-base border border-border-color px-2 py-1 text-sm outline-none focus:border-primary-color sm:ml-3"
                  />
                  <input
                    formControlName="horario"
                    *ngIf="isScheduled"
                    id="schedule_time"
                    type="time"
                    class="w-full rounded-base border border-border-color px-2 py-1 text-sm outline-none focus:border-primary-color sm:ml-3"
                  />
                </div>
                <div id="business_hours_option" class="flex items-center">
                  <input
                    formControlName="hComercial"
                    id="business_hours_checkbox"
                    type="checkbox"
                    class="h-4 w-4 text-primary-color border-border-color rounded"
                  />
                  <label for="business_hours_checkbox" class="ml-3 block text-sm text-dark-color">Disparar somente em horario comercial (08:00 as 19:00)</label>
                </div>
                <div id="saturday_sending_option" class="flex items-center">
                  <input
                    formControlName="saturday"
                    id="sunday_sending_checkbox"
                    type="checkbox"
                    class="h-4 w-4 text-primary-color border-border-color rounded"
                  />
                  <label for="sunday_sending_checkbox" class="ml-3 block text-sm text-dark-color">Disparar aos sabados</label>
                </div>
                <div id="sunday_sending_option" class="flex items-center">
                  <input
                    formControlName="sunday"
                    id="sunday_sending_checkbox"
                    type="checkbox"
                    class="h-4 w-4 text-primary-color border-border-color rounded"
                  />
                  <label for="sunday_sending_checkbox" class="ml-3 block text-sm text-dark-color">Disparar aos domingos</label>
                </div>
              </div>
            </div>
            <div class="border-t border-border-color pt-6">
              <div id="whatsapp_terms_option" class="flex items-center">
                <input
                  name="acceptTerm"
                  formControlName="acceptTerm"
                  type="checkbox"
                  class="h-4 w-4 text-primary-color border-border-color rounded"
                  required
                />
                <label for="whatsapp_terms_checkbox" class="ml-3 block text-sm text-dark-color">
                  <a href="https://www.whatsapp.com/legal/terms-of-service?lang=pt_BR" target="_blank">Concordo com os Termos do Whatsapp</a>
                  <span class="text-dark-color/60">*</span>
                </label>
              </div>
              <div id="whatsapp_terms_option" class="flex items-center">
                <input
                  name="acceptTermPlataform"
                  formControlName="acceptTermPlataform"
                  (change)="handleShowTerm()"
                  type="checkbox"
                  class="h-4 w-4 text-primary-color border-border-color rounded"
                  required
                />
                <label for="whatsapp_terms_checkbox" class="ml-3 block text-sm text-dark-color">
                  <a href="/app/termo-disparo-oficial" target="_blank">Concordo com os Termos da Plataforma</a>
                  <span class="text-dark-color/60">*</span>
                </label>
              </div>
            </div>
          </section>
          <footer class="flex flex-col gap-2 border-t border-border-color pt-4 sm:flex-row sm:justify-end sm:gap-3">
            <button
              (click)="previousStep()"
              id="cancel_button_3"
              type="button"
              class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color">
              Voltar
            </button>
            <button
              (click)="handleSubmitFire()"
              [disabled]="!handleValidStepThree()"
              id="continue_button_3"
              type="submit"
              class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-60">
              <i class="fa-solid fa-arrow-right mr-2"></i>Continuar
            </button>
          </footer>
        </form>
      </div>
    </section>
  </main>
</div>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
